<div class="button-wrap {{ theme() }}">
  <p-button
    [type]="type()"
    [style]="styles()"
    (onClick)="click($event)"
    [loading]="isLoading()"
    [disabled]="disabled()"
    [severity]="severity()"
    [size]="$any(size())"
    [styleClass]="mergedClasses()"
    [text]="text()"
    [outlined]="outlined()"
    [dt]="dt()">
    <ng-template #content>
      @if (iconPos() === "left" && iconName()) {
        <sxw-svg-icon
          [name]="iconName()"
          [strokeColor]="iconStrokeColor()"
          [strokeWidth]="iconStrokeWidth()"
          [fillColor]="iconPos() === 'left' ? leftIconFill() : rightIconFill()"
          [width]="iconWidth()"
          [height]="iconHeight()"
          class="p-button-icon"></sxw-svg-icon>
      }

      @if (label() && label() !== "EMPTY") {
        <span class="p-button-label">{{ label() | translate }}</span>
      }

      @if (iconPos() === "right" && iconName()) {
        <sxw-svg-icon
          [name]="iconName()"
          [strokeColor]="iconStrokeColor()"
          [strokeWidth]="iconStrokeWidth()"
          [fillColor]="iconPos() === 'left' ? leftIconFill() : rightIconFill()"
          [width]="iconWidth()"
          [height]="iconHeight()"
          class="p-button-icon"></sxw-svg-icon>
      }
    </ng-template>
  </p-button>
</div>
